var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"src":_vm.src,"alt":_vm.alt,"loading":_vm.loading},on:{"error":function($event){$event.target.src = _vm.fallback}}})}
var staticRenderFns = []

export { render, staticRenderFns }